'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = Filters;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _domClasslist = require('dom-classlist');

var _domClasslist2 = _interopRequireDefault(_domClasslist);

function Filters() {
	var _filterForms = document.querySelectorAll('#filtersForm');
	if (!_filterForms) return;

	addHandlers();

	function addHandlers() {
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = _filterForms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var form = _step.value;

				var _filters = form.querySelectorAll('label');
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = _filters[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var el = _step2.value;

						el.addEventListener('click', clickFilter);
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2['return']) {
							_iterator2['return']();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator['return']) {
					_iterator['return']();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		initFilters();
	}

	function clickFilter(e) {
		_pubsub2['default'].emit('load:getStatus', function (isLoading) {
			if (isLoading) {
				e.preventDefault();
			} else {
				var _iteratorNormalCompletion3;

				var _didIteratorError3;

				var _iteratorError3;

				var _iterator3, _step3;

				(function () {
					var _labelClicked = e.target,
					    _relatedInput = _labelClicked.parentNode.querySelector('input');

					//comportement de radiobutton pour les "fake radio" (radio buttons qu'on peut uncheck > ajout de .fake-radio à l'input type checkbox)
					if ((0, _domClasslist2['default'])(_relatedInput).contains('fake-radio')) {
						var _fakeRadios = _relatedInput.parentNode.parentNode.querySelectorAll('.fake-radio');
						_iteratorNormalCompletion3 = true;
						_didIteratorError3 = false;
						_iteratorError3 = undefined;

						try {
							for (_iterator3 = _fakeRadios[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
								var el = _step3.value;

								if (el !== _relatedInput) el.checked = false;
							}
						} catch (err) {
							_didIteratorError3 = true;
							_iteratorError3 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion3 && _iterator3['return']) {
									_iterator3['return']();
								}
							} finally {
								if (_didIteratorError3) {
									throw _iteratorError3;
								}
							}
						}
					}

					// timeout pour serialize form OK
					setTimeout(function () {
						_pubsub2['default'].emit('load:more', true, _relatedInput.form);
					}, 200);
				})();
			}
		});
	}

	function initFilters() {
		var mobileGaleryFilters = document.querySelector('.gallery-container-mobile #filtersForm, .actualites-presse_77008 #filtersForm');
		if (mobileGaleryFilters) {
			var filterOpen = false;
			var title = mobileGaleryFilters.querySelector('.module-title');
			if (title) {
				title.addEventListener('click', function () {
					if (!filterOpen) {
						(0, _domClasslist2['default'])(mobileGaleryFilters).add('open');
						mobileGaleryFilters.querySelector('.filters_attribute').style.height = "auto";

						var h = mobileGaleryFilters.querySelector('.filters_attribute').offsetHeight;
						mobileGaleryFilters.querySelector('.filters_attribute').style.height = "0px";

						TweenMax.to(mobileGaleryFilters.querySelector('.filters_attribute'), 0.3, { height: h });
						filterOpen = true;
					} else {
						(0, _domClasslist2['default'])(mobileGaleryFilters).remove('open');

						TweenMax.to(mobileGaleryFilters.querySelector('.filters_attribute'), 0.3, { height: 0 });
						filterOpen = false;
					}
				});
			}
		}
	}
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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